export default __webpack_public_path__ + "static/media/News.06ac954f.svg";